import { $count } from "foundation-ts/commons";
import { SessionDto } from "doxecure-commons/doxecureClientTypes";
import { SignatureStatus } from "doxecure-commons/doxecureModelTypes";
import { SectionCategory, SessionActorType } from "doxecure-commons/doxecureTypes";

import { Dashboard, SessionFilter } from "@containers/generics/Dashboard";
import { useAuthContext } from "@hooks/useAuthContext";
import { okOrError, optlog, defaultSectionInformations } from "@utils/functions";

export const ToBeSignedDocumentsView = () => {
    const { connectedProfileId } = useAuthContext() ;
    const sessionFilter:SessionFilter = (session:SessionDto, _:SectionCategory): boolean => {
        const nbAlreadySigned = $count(session.signatures?.filter(s => s.signatureStatus === SignatureStatus.Signed));
        const nbSignatures = $count(session.signatures);
        if (((nbSignatures - nbAlreadySigned) === 1) && (session.signatures?.findIndex(s => s.signatureStatus === SignatureStatus.Opened && s.signer.apid === connectedProfileId) !== -1)) {
            return false; // If connected user is the last signer, then session must be hidden into this category
        } else {
            return session.creator === connectedProfileId || session.expeditor.apid === connectedProfileId;
        }
    }
    optlog(`+++ ToBeSignedDocumentsView initialized with profile ID '${connectedProfileId}'`) ;
    
    return okOrError(
        connectedProfileId,
        (<Dashboard 
            title="Documents en attente de signature"
            emptyMessage="Pas de documents en attente de signature"
            category="to-be-signed"
            roles={[SessionActorType.Creator, SessionActorType.Expeditor, SessionActorType.Approver, SessionActorType.Signer]} 
            sectionInfos={defaultSectionInformations} 
            sessionFilter={sessionFilter}
        />),
        false,
        "Impossible d'afficher la liste des documents en attente de signature car l'identifiant de profil de la personne connectée n'a pas pu être récupéré.",
        "Connexion invalide"
    ) ;
};
